const SvgHardware1 = (props) => (
  <>
    <path d="M64 32v32H32V32h32M96 0H0v96h96V0Z" fill={props.p40} />
  </>
);

export default SvgHardware1;
